import axios from 'axios';
import { toast } from 'react-toastify';

export const execute = (
  method,
  path = '',
  body = {},
  responseType = 'json',
  contentType = 'application/json'
) => {
  let headers = {
    'Content-Type': contentType,
  };
  axios.interceptors.request.use(async (config) => {
    document.body.classList.add('loading-indicator');
    return config;
  });

  axios.interceptors.response.use(
    async (response) => {
      document.body.classList.remove('loading-indicator');
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        window.location.href = '/ui/logout';
      }
      if (error.response.status === 500) {
        toast.error('Internal Server Error');
      }
    }
  );

  return axios.request({
    method,
    headers,
    responseType,
    url: `${path}`,
    data: contentType === 'application/json' ? JSON.stringify(body) : body,
  });
};
